// 32 characters without 0, O, 1, I: easy to read out loud
const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'

// 20 random characters = 100 bits. Never let people choose their own passcode: weak ones can be guessed.
export const generatePasscode = () => {
  const bytes = crypto.getRandomValues(new Uint8Array(20))
  return Array.from(bytes, (b) => ALPHABET[b % 32]).join('')       // 256 % 32 = 0: no bias
}

export const normalizePasscode = (text) => String(text || '').toUpperCase().replace(/[^A-Z2-9]/g, '')

export const formatPasscode = (passcode) => (passcode || '').match(/.{1,5}/g)?.join('-') || ''

// Lets a joiner check the passcode before connecting. It tells the server nothing useful.
export const computeKeyCheck = async (passcode) => {
  const data = new TextEncoder().encode(`lk-e2ee-check:${passcode}`)
  const hash = new Uint8Array(await crypto.subtle.digest('SHA-256', data))
  return btoa(String.fromCharCode(...hash)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '').slice(0, 22)
}